import { Observable } from '@bingads-webui-universal/observable';
import type { ICacheEventObserver } from './types';

export class CacheEvent extends Observable {
  observers: Set<ICacheEventObserver>;

  constructor() {
    super((observer: ICacheEventObserver) => {
      this.observers.add(observer);
      return () => {
        this.observers.delete(observer);
      };
    });

    this.observers = new Set();
  }

  notify(type: string, entity: unknown) {
    this.observers.forEach((ob: ICacheEventObserver) => {
      ob.next({
        type,
        entity,
      });
    });
  }
}
